import { css } from '@emotion/css';

export const bankAccountInputCx = css`
  .bank-account-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    .bank-account-input {
      flex: 1;
      margin-right: 1rem;
    }

    .bank-account-verify-btn {
      padding: 0.675rem;
      min-width: 7.5rem;
      .check-icon {
        margin-left: 0.5rem;
      }
    }
  }
`;
